import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import {
  SingleInvitation,
  SingleInvitationProps,
} from './single-invitation/single-invitation';

export interface InvitationsListProps {
  data: SingleInvitationProps[];
  status: LoadingState;
}

export const InvitationsList = types
  .model({
    data: types.optional(types.array(SingleInvitation), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: InvitationsListProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
  }))
  .actions((self) => ({
    async setInvitations(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.invitationsList,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setInvitations();
    },
  }))
  .views((self) => ({
    getRecentInvitations(size = 9): SingleInvitationProps[] {
      const { data } = self;
      return getSnapshot(data).slice(0, size);
    },
    getInvitations(): SingleInvitationProps[] {
      const { data } = self;
      return getSnapshot(data);
    },
  }));

export const invitationsList = InvitationsList.create();
export type InvitationsListSnapshot = SnapshotIn<typeof InvitationsList>;
export type InvitationsListInstance = Instance<typeof InvitationsList>;
export default invitationsList;
